import { useQuery } from "@tanstack/react-query";
import { getStudentPerformance, getFailingStudents } from "./index";

export const useGetStudentPerformance = () => {
  return useQuery({
    queryKey: ["student-performance"],
    queryFn: getStudentPerformance,
  });
};

export const useGetFailingStudents = () => {
  return useQuery({
    queryKey: ["failing-students"],
    queryFn: getFailingStudents,
  });
};
